// extracted by mini-css-extract-plugin
export default {"about":"About_about__yUZyc","left":"About_left__s4Pt2","right":"About_right__CMc2T","icons":"About_icons__Vo3aJ"};